import { gql } from "apollo-boost";

export const getSubmissionActivitySchedule = gql`
  query SubmissionActivitySchedule($id: ID!) {
    SubmissionActivitySchedule(id: $id) {
        id
        orderIndex
        description
        activities {
          id
          isBlocking
          title
          orderIndex
          description
          responsible
          methodology
          formula
          meansOfVerification
          baseline
          goal
          place
          months
          inputs
          products
        }
    }
  }
`